import * as icon from "@mdi/js";
import Icon from "@mdi/react";
import React from "react";
import { useManagedProp } from "@corejs";

const DEFAULT = "mdiClockOutline";
const initializer = ({ size = 1, name, rotate, color, spin }) => ({
  size,
  name: !name ? DEFAULT : !icon[`mdi${name}`] ? DEFAULT : `mdi${name}`,
  rotate,
  color,
  spin,
});
const MIcon = ({ style, className, onClick, ...rest }, ref) => {
  const iconRef = React.useRef(null);
  const managed = useManagedProp(rest, initializer);
  const [, render] = React.useState(0);
  const api = React.useMemo(() => {
    return {
      get El() {
        return iconRef.current;
      },
      get name() {
        return managed.name;
      },
      set name(value) {
        managed.name = !value
          ? DEFAULT
          : !icon[`mdi${value}`]
          ? DEFAULT
          : `mdi${value}`;
        render((v) => v + 1);
      },
      get size() {
        return managed.size;
      },
      set size(value) {
        managed.size = value;
        iconRef.current.size = value;
        render((v) => v + 1);
      },
      get rotate() {
        return managed.rotate;
      },
      set rotate(value) {
        managed.rotate = value;
        iconRef.current.rotate = value;
        render((v) => v + 1);
      },
      get color() {
        return managed.color;
      },
      set color(value) {
        managed.color = value;
        iconRef.current.color = value;
        render((v) => v + 1);
      },
      get spin() {
        return managed.spin;
      },
      set spin(value) {
        managed.spin = value;
        iconRef.current.spin = value;
        render((v) => v + 1);
      },
    };
  }, [managed]);
  React.useImperativeHandle(ref, () => api);

  return (
    <Icon
      path={icon[managed.name]}
      size={managed.size}
      color={managed.color}
      ref={iconRef}
      className={className}
      rotate={managed.rotate}
      onClick={onClick}
      style={style}
      spin={managed.spin}
    />
  );
};
const IconSkeleton = () => {
  return <div className="icon-skeleton"></div>;
};
const outer = React.forwardRef(MIcon);
outer.skeleton = <IconSkeleton />;

export default outer;
export { outer as MSIcon };
